export default __webpack_public_path__ + "static/media/vire18.7acf2047.jpg";